import React, { FunctionComponent } from 'react';
import Grid from '@material-ui/core/Grid';
import SummaryTaxesRow from './SummaryTaxesRow';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import { GetCustomizeCar_customizeCar_prices_totalPrice } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import usePrice from '../../../../../../../../gqlCommon/hooks/prices/usePrice';
import { usePersistedCurrencyPreference } from '../../../../../../../../gqlCommon/hooks/currency/usePersistedCurrencyPreference';
import { TaxTypes } from '../../../../../../../../../../common/enum/TaxTypes';

export interface ISummaryTaxesProps {
  prices: GetCustomizeCar_customizeCar_prices_totalPrice[];
  currency: string;
  loading?: boolean;
}

const SummaryTaxes: FunctionComponent<ISummaryTaxesProps> = ({ prices, currency, loading }) => {
  const styles = summaryLabelStyles();

  const { primaryPrice, secondaryPrice } = usePrice(prices);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();

  const taxes = (
    (isSecondaryCurrencyDisplay ? secondaryPrice : primaryPrice) as GetCustomizeCar_customizeCar_prices_totalPrice
  ).taxes;

  const displayedTaxes = taxes?.filter(tax => !tax.aggregated && tax.type !== TaxTypes.GVT);

  if (!displayedTaxes?.length) {
    return null;
  }

  return (
    <Grid
      container={true}
      data-test="customise:summary:taxes_container"
      justifyContent={'space-between'}
      spacing={3}
      className={styles.lineContainer}
      classes={{ root: styles.container }}
    >
      {displayedTaxes.map(tax => (
        <SummaryTaxesRow key={tax.type} loading={loading} currency={currency} tax={tax} />
      ))}
    </Grid>
  );
};

export default SummaryTaxes;
